<script>
import {Link} from "@inertiajs/vue3";

export default {
    components: {Link},
    props: {
        organisation: Object,
    },
}
</script>

<template>
    <div>
        <div class="hidden sm:block">
            <div class="border-b border-gray-200">
                <nav class="-mb-px flex space-x-8" aria-label="Tabs">
                    <Link
                        :href="organisation.type === 'supplier' ? route('frontend.organisations.suppliers.organisation.show' , organisation.id) : route('frontend.organisations.clients.organisation.show' , organisation.id)"
                        :class="[
                            $page.component.startsWith('Frontend/Organisations/Create') ?
                                'border-light-pitch-purple text-pitch-purple' :
                                'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300',
                                'whitespace-nowrap py-4 px-1 border-b-2 text-sm'
                        ]"
                    >
                        Details
                    </Link>
                    <Link
                        :href="organisation.type === 'supplier' ? route('frontend.organisations.suppliers.organisation.fixtures.show' , organisation.id) : route('frontend.organisations.clients.organisation.fixtures.show' , organisation.id)"
                        :class="[
                            $page.component.startsWith('Frontend/Organisations/Components/Fixtures') ?
                                'border-light-pitch-purple text-pitch-purple' :
                                'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300',
                                'whitespace-nowrap py-4 px-1 border-b-2 text-sm'
                        ]"
                    >
                        Fixtures
                    </Link>
                    <Link
                        v-if="organisation.type === 'supplier'"
                        :href="route('frontend.organisations.suppliers.organisation.commission-invoices.show' , organisation.id)"
                        :class="[
                            $page.component.startsWith('Frontend/Organisations/Components/CommissionInvoices') ?
                                'border-light-pitch-purple text-pitch-purple' :
                                'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300',
                                'whitespace-nowrap py-4 px-1 border-b-2 text-sm'
                        ]"
                    >
                        Commission Invoices
                    </Link>
                    <Link
                        v-if="organisation.type === 'supplier'"
                        :href="route('frontend.organisations.suppliers.organisation.supplier-invoices.show' , organisation.id)"
                        :class="[
                            $page.component.startsWith('Frontend/Organisations/Components/SupplierInvoices') ?
                                'border-light-pitch-purple text-pitch-purple' :
                                'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300',
                                'whitespace-nowrap py-4 px-1 border-b-2 text-sm'
                        ]"
                    >
                        Supplier Invoices
                    </Link>
                    <Link v-if="this.$page.props.auth.user_role != 3"
                        :href="organisation.type === 'supplier' ? route('frontend.organisations.suppliers.organisation.commission-rate.show' , organisation.id) : route('frontend.organisations.clients.organisation.commission-rate.show' , organisation.id)"
                        :class="[
                            $page.component.startsWith('Frontend/Organisations/SupplierCommission') ?
                                'border-light-pitch-purple text-pitch-purple' :
                                'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300',
                                'whitespace-nowrap py-4 px-1 border-b-2 text-sm'
                        ]"
                    >
                        Commission Rates
                    </Link>
                </nav>
            </div>
        </div>
    </div>
</template>
